// exports all files from this directory
// Directory contains store configurations, generic reducers, combined reducer, persistor config etc.

import store from './configure-store';
import initPersistence from './helper/persistance';

const { persistor, purge, pause, resume } = initPersistence(store);

export { store, persistor, purge, pause, resume };
export * from './types';
